<template>
  <div style="margin: 0 auto; max-width: 500px;padding: 10px;min-width: 500px;">
    <h3 style="text-align: center;">{{ $t('All.冲压') }}/{{ $t('All.注塑补标识卡') }}</h3>
    <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="auto"
    label-position="right">
      <el-form-item :label="$t('All.工单号')" prop="Gd">
        <el-input v-model="formData.Gd" :placeholder="$t('All.请输入工单号')" clearable :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item :label="$t('All.品名')" prop="Product_name">
        <el-input v-model="formData.Product_name" :placeholder="$t('All.请输入品名')" clearable :style="{width: '100%'}">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('All.规格')" prop="Gg">
        <el-input v-model="formData.Gg" :placeholder="$t('All.请输入规格')" clearable :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item :label="$t('All.料号')" prop="Item_no">
        <el-input v-model="formData.Item_no" :placeholder="$t('All.请输入料号')" clearable :style="{width: '100%'}">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('All.生产日期')" prop="Cdate">
        <el-date-picker v-model="formData.Cdate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          :style="{width: '100%'}" :placeholder="$t('All.请选择生产日期')" clearable></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('All.入库日期')" prop="Rdate">
        <el-date-picker v-model="formData.Rdate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          :style="{width: '100%'}" :placeholder="$t('All.请选择入库日期')" clearable></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('All.单位')" prop="Dw">
        <el-select v-model="formData.Dw" filterable allow-create :placeholder="$t('All.单位')" @change="chuangjcompany" :style="{width: '100%'}">
          <el-option label="G" value="G"></el-option>
          <el-option label="KG" value="KG"></el-option>
          <el-option label="PC" value="PC"></el-option>
          <el-option label="M" value="M"></el-option>
          <el-option label="KM" value="KM"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('All.Lot号')">
        <el-input v-model="formData.Lot" :placeholder="$t('All.请输入Lot号')" clearable :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item :label="$t('All.机台')">
        <el-input v-model="formData.Jt" :placeholder="$t('All.请输入机台')" clearable :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item :label="$t('All.班别')">
        <el-input v-model="formData.Bb" :placeholder="$t('All.请输入班别')" clearable :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item :label="$t('All.操作员')">
        <el-input v-model="formData.Czu" :placeholder="$t('All.请输入操作员')" clearable :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item :label="$t('All.生产数量')" prop="Scsl">
        <el-input v-model="formData.Scsl" :placeholder="$t('All.请输入生产数量')" onkeyup="value=value.replace(/[^\d^\.]/g,'')" oninput="if (value.trim() === '') { value = null; } if (isNaN(value)) { value = null; } if (value.indexOf('.') > 0) { value = value.slice(0, value.indexOf('.') + 5); }" clearable :style="{width: '100%'}"></el-input>
      </el-form-item>
      <el-form-item
        v-for="(domain, index) in Boxlist"
        :label="$t('All.数量')"
        :key="index"
      >
        <el-input v-model="domain.Boxquantity" style="width:100px;" onkeyup="value=value.replace(/[^\d^\.]/g,'')" oninput="if (value.trim() === '') { value = null; } if (isNaN(value)) { value = null; } if (value.indexOf('.') > 0) { value = value.slice(0, value.indexOf('.') + 5); }" autocomplete="off"></el-input>
        <span style="padding: 10px;">{{$t('All.张数')}}:</span><el-input v-model="domain.Box" onkeyup="value=value.replace(/[^\d^\.]/g,'')" oninput="if (value.trim() === '') { value = null; } if (isNaN(value)) { value = null; } if (value.indexOf('.') > 0) { value = null; }" style="width:100px;" autocomplete="off"></el-input><el-button v-show="index + 1 === Boxlist.length" style="margin-left: 11px;" size="mini" type="primary" icon="el-icon-plus"  @click="addDomainbut()"></el-button><el-button v-show="Boxlist.length > 1" size="mini" type="danger" icon="el-icon-delete"  @click="removeDomainbut(domain)"></el-button>
      </el-form-item>
      <el-form-item :label="$t('All.打印机')">
          <el-select :style="{width: '100%'}" v-model="Printname" value-key="Id" :placeholder="$t('All.请选择打印机')">
            <el-option
              v-for="item in this.$store.state.PrinterData"
              :key="item.Name"
              :label="item.Wz"
              :value="item">
          </el-option>
          </el-select>
        </el-form-item>
      <el-form-item size="large" style="text-align: center;">
        <el-button type="primary" @click="submitForm">{{$t('All.提交')}}</el-button>
        <el-button @click="resetForm">{{$t('All.重置')}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  components: {},
  props: [],
  data () {
    var geigd = (rule, value, callback) => {
      this.GetERP(value)
      callback()
    }
    return {
      formData: {
        Product_name: '',
        Serialcode: '',
        Gg: '',
        Item_no: '',
        Lot: '',
        Bb: '',
        Rdate: new Date(),
        Cdate: new Date(),
        Scsl: '',
        DScsl: 0,
        Czu: this.$store.state.Login.Username,
        Czuuser: this.$store.state.Login.User,
        Gd: '',
        Jt: '',
        State: 0,
        Type: 3,
        Fby: '',
        Fbyuser: '',
        Cid: 0,
        Numbers: '',
        Syr: '',
        Syruser: '',
        DW: 'PC',
        Region: this.$store.state.Login.Factory
      },
      rules: {
        Product_name: [{
          required: true,
          message: this.$t('All.请输入品名'),
          trigger: 'blur'
        }],
        Gg: [{
          required: true,
          message: this.$t('All.请输入规格'),
          trigger: 'blur'
        }],
        Item_no: [{
          required: true,
          message: this.$t('All.请输入料号'),
          trigger: 'blur'
        }],
        Cdate: [{
          required: true,
          message: this.$t('All.请选择生产日期'),
          trigger: 'change'
        }],
        Rdate: [{
          required: true,
          message: this.$t('All.请选择入库日期'),
          trigger: 'change'
        }],
        Lot: [{
          required: true,
          message: this.$t('All.请输入Lot号'),
          trigger: 'blur'
        }],
        Gd: [{
          required: true,
          message: this.$t('All.请输入工单号'),
          trigger: 'blur'
        }, {
          required: true,
          validator: geigd,
          trigger: 'blur'
        }],
        Jt: [{
          required: true,
          message: this.$t('All.请输入机台'),
          trigger: 'blur'
        }],
        Bb: [{
          required: true,
          message: this.$t('All.请输入班别'),
          trigger: 'blur'
        }],
        Scsl: [{
          required: true,
          message: this.$t('All.请输入生产数量'),
          trigger: 'blur'
        }]
      },
      Printname: '',
      Boxlist: [
        {
          Box: 1,
          Boxquantity: 1
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    addDomainbut () {
      this.Boxlist.push({
        Box: 1,
        Boxquantity: 1
      })
    },
    removeDomainbut (item) {
      this.$confirm(this.$t('All.是否删除此节点'), this.$t('All.提示'), {
        confirmButtonText: this.$t('All.确认'),
        cancelButtonText: this.$t('All.取消'),
        type: 'warning'
      })
        .then(() => {
          if (this.Boxlist.length === 1) {
            return this.$message.error(this.$t('All.最少保留一列'))
          }
          var index = this.Boxlist.indexOf(item)
          if (index !== -1) {
            this.Boxlist.splice(index, 1)
          }
        })
        .catch(() => {
        })
    },
    submitForm () {
      this.formData.DScsl = this.formData.Scsl
      const loadingInstance = this.$loading({ text: this.$t('All.打印中'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        if (this.Printname.length < 1) {
          loadingInstance.close()
          return this.$message.error(this.$t('All.请选择打印机后在进行打印'))
        }
        this.$refs.elForm.validate(async valid => {
          if (!valid) {
            loadingInstance.close()
            return this.$message.error(this.$t('All.数据填写不完整'))
          }
          var isbool = 0
          this.Boxlist.forEach(element => {
            isbool += parseInt(element.Box)
          })
          if (isbool > 10) {
            loadingInstance.close()
            this.$confirm(`${this.$t('All.确认要打印')}${isbool}${this.$t('All.张')}？`, this.$t('All.提示'), {
              confirmButtonText: this.$t('All.确认'),
              cancelButtonText: this.$t('All.取消'),
              type: 'warning'
            })
              .then(async () => {
                const loadingInstance1 = this.$loading({ text: this.$t('All.打印中'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
                const postdata = {
                  Boxlist: this.Boxlist,
                  CYClass: this.formData,
                  PrinterData: this.Printname,
                  UserData: this.$store.state.Login
                }
                const { data: res } = await this.$http.post('/api/Semifinished/BCYSeleUserData', postdata)
                if (res.status !== 200) return this.$message.error(res.msg)
                loadingInstance1.close()
                this.$message.success(res.msg)
                this.$refs.elForm.resetFields()
              })
              .catch(() => {
              })
            return
          }
          const loadingInstance2 = this.$loading({ text: this.$t('All.打印中'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
          const postdata = {
            Boxlist: this.Boxlist,
            CYClass: this.formData,
            PrinterData: this.Printname,
            UserData: this.$store.state.Login
          }
          const { data: res } = await this.$http.post('/api/Semifinished/BCYSeleUserData', postdata)
          if (res.status !== 200) {
            loadingInstance2.close()
            return this.$message.error(res.msg)
          }
          loadingInstance2.close()
          this.$message.success(res.msg)
          this.$refs.elForm.resetFields()
        })
      } catch (error) {
        loadingInstance.close()
      }
    },
    resetForm () {
      this.$refs.elForm.resetFields()
    },
    async GetERP (value) {
      const { data: res } = await this.$http.get(`api/Semifinished/GetERP?Gongdan=${value}`)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.formData.Product_name = res.response.Imdsc1
      this.formData.Gg = res.response.Imdsc2
      this.formData.Item_no = res.response.Walitm
      this.formData.Scsl = res.response.Wauorg
      this.$message.success(this.$t('All.系统检测已帮申请过的信息自动填写'))
    },
    chuangjcompany () {
      var inputValue = this.formData.Dw
      // 移除非字母字符
      inputValue = inputValue.replace(/[^A-Za-z]/g, '')
      // 转换为大写
      inputValue = inputValue.toUpperCase()
      this.formData.Dw = inputValue
    }
  }
}

</script>
<style>
</style>
